"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfferSlug = exports.getIntroSlug = void 0;
const config_1 = require("config");
const constants_1 = require("./constants");
const getIntroSlug = () => {
    const slug = constants_1.BASE_PATH_EDS + config_1.PATH.EDS.INDEX;
    const url = (0, config_1.makePath)(slug);
    return url;
};
exports.getIntroSlug = getIntroSlug;
const getOfferSlug = () => {
    const slug = constants_1.BASE_PATH_EDS + config_1.PATH.EDS.WATERFALL;
    const url = (0, config_1.makePath)(slug);
    return url;
};
exports.getOfferSlug = getOfferSlug;
